<template>
  <!-- UpdateDayTrip -->
  <div>
    <main-farme>
      <!-- --------------------------------------------左变栏-------------------------------------------- -->
      <div slot="aside-left">
        <div style="width:350px">
          <!-- 地图 和 迹点筛选/列表 -->
          <select-traver-point ref="select_traver_point"
                               @checkOneItemToDayTrip="checkOneItemToDayTrip"></select-traver-point>
        </div>
      </div>
      <!-- --------------------------------------------日行程设计-------------------------------------------- -->
      <div slot="main">
        <el-card shadow="never"
                 :body-style="{ padding: '10px'}"
                 style="margin-bottom:5px">
          <div class="day-trip-detail">
            <!-- 日行程配置：旅行模式、行程状态、建议出发时间、可选日期、主题、 -->
            <!-- 目的地 -->
            <div style="margin-bottom:5px;display:flex">

              <select-dest @selectDest="selectDest"
                           :selectInputWidth="160"
                           :destShowBack="destShowBack"
                           placeholder="选择行程所在目的地"></select-dest>

              <span style="margin-left:10px">
                <time-input @timeChange="suggestTimeChange"
                            placeHolder="建议出发时间"
                            :select_time="select_time"
                            :time_list="suggestOptions"></time-input>
              </span>

            </div>

            <!-- 行程状态 -->
            <div class="trip_attritube_style">
              <el-radio-group v-model="dayAtrribute.trip_type"
                              size="mini">
                <el-radio-button label="2">整日</el-radio-button>
                <el-radio-button label="3">离开</el-radio-button>
                <el-radio-button label="4">中转</el-radio-button>
                <el-radio-button label="1">抵达</el-radio-button>
              </el-radio-group>
            </div>
            <!-- 旅行方式 -->
            <div class="trip_attritube_style">
              <el-radio-group v-model="dayAtrribute.trip_mode"
                              size="mini">
                <el-radio-button label="1">探索模式</el-radio-button>
                <el-radio-button label="2">自驾/租车</el-radio-button>
                <el-radio-button label="3">拼团</el-radio-button>
              </el-radio-group>
            </div>
            <!-- 输入框 -->
            <el-input type="textarea"
                      :rows="3"
                      placeholder="请输入行程备注内容"
                      resize="none"
                      v-model="dayAtrribute.remarkDayTrip">
            </el-input>
          </div>
        </el-card>
        <!-- --------已选择的迹点，罗列在日行程中-------- -->
        <el-card :body-style="{ padding: '10px'}"
                 style="margin-bottom:5px"
                 shadow="never">
          <div v-if="dayTrip.length == 0"
               style="text-align:center;color:grey">
            请从左侧选择迹点
          </div>
          <div v-else>
            <check-day-trip-list ref="day_trip_list"
                                 :dayTrip="dayTrip"
                                 :TrafficPlanList="TrafficPlanList"
                                 @openTrafficEditor="openTrafficEditor"></check-day-trip-list>
          </div>

        </el-card>
        <el-card :body-style="{ padding: '10px'}">
          <el-button style="width:100%;"
                     type="primary"
                     @click="updateDayTripList"
                     size="mini">更新日行程</el-button>

        </el-card>
        <!-- 检查日行程数据 -->
        <el-card :body-style="{ padding: '10px'}">

          <el-button style="width:100%;"
                     type="primary"
                     @click="checkDayTripList"
                     size="mini">检查数据</el-button>
        </el-card>
      </div>
      <!-- --------------------------------------------右侧边栏-------------------------------------------- -->
      <div style="width: 500px;"
           slot="aside-right">

        <!-------------------------------- 两点路线地图 -------------------------------->
        <div>
          <el-card shadow="never"
                   id="get_map_height"
                   style="position:fixed;z-index:1001;width:auto;"
                   :body-style="{ padding: '10px'}">
            <!-- 标签页 -->
            <el-tabs class="tab-way-map"
                     v-model="routeMode"
                     @tab-click="clickRouteMode"
                     type="border-card">
              <el-tab-pane name="walking"
                           label="徒步"></el-tab-pane>
              <el-tab-pane name="driving"
                           label="驾车"></el-tab-pane>
              <el-tab-pane name="bicycling"
                           label="骑行"></el-tab-pane>
              <el-tab-pane name="transit"
                           label="公交"></el-tab-pane>
            </el-tabs>

            <!-- 地图 -->
            <div style="border:1px solid lightgrey">
              <show-route ref="show_route_maps"
                          @showOrHideMapFunction="showOrHideMapFunction"
                          :routeMode="routeMode"
                          :fromLat="fromLat"
                          :fromLng="fromLng"
                          :toLat="toLat"
                          :toLng="toLng"></show-route>
            </div>

          </el-card>
        </div>
        <div :style="filterBlock"></div>
        <div>
          <!-- 公交方案选择 的组件：-->
          <div>
            <transit-plan-show v-if="showTransit"
                               @selectTransitPlan="selectTransitPlan"
                               @bandTransitPlan="bandTransitPlan"
                               :planData="planData"></transit-plan-show>
          </div>
          <!-- 驾车方案选择 的组件：-->
          <div>
            <driving-plan-show v-if="showDriving"
                               @selectDrivingPlan="selectDrivingPlan"
                               @bandTransitPlan="bandTransitPlan"
                               :planData="planData"></driving-plan-show>
          </div>

          <!-- ------------------------------ 编辑/选择交通方案 ------------------------------>

          <el-card style="margin-bottom:5px"
                   :body-style="{ padding: '10px'}"
                   shadow="nerver">
            <traffic-editor ref="traffic_editor"
                            :TraverNameBetween="TraverNameBetween"
                            :TraverBetween="traver_between"
                            :TrafficId="TrafficId"
                            :routeMode="routeMode"
                            :TaxiIntroduce="TaxiIntroduce"
                            :TaxiFare="TaxiFare"
                            :planOfMap="planOfMap"
                            :TrafficIntroduce="TrafficIntroduce"
                            :TrafficPlan="TrafficPlan"
                            @selectTrafficPlan="selectTrafficPlan"></traffic-editor>
          </el-card>
        </div>
      </div>
    </main-farme>
  </div>
</template>

<script>
import MainFrame from '../../components/common/main/MainFrame'
import SelectTraverPoint from '../../components/common/select/SelectTraverPoint'
import CheckDaytripList from '../../components/traver/CheckDayTripList'
//
import TrafficEditor from '../../components/traver/TrafficEditor'
import ShowRoute from '../../components/map/RouteShow'
import SelectDest from '../../components/common/select/SelectDest'
import TimeInput from '../../components/common/input/TimeInput'
//
import TransitPlanShow from '../../components/traver/TransitPlanShow'
import DrivingPlanShow from '../../components/traver/DrivingPlanShow'

export default {
  name: 'day-trip',
  components: {
    'main-farme': MainFrame,
    'check-day-trip-list': CheckDaytripList,
    SelectTraverPoint,
    TrafficEditor,
    ShowRoute,
    SelectDest,
    TimeInput,
    TransitPlanShow,
    DrivingPlanShow,
  },
  data() {
    return {
      suggestOptions: [
        {
          value: '自然醒',
        },
        {
          value: '08:00',
        },
        {
          value: '10:00',
        },

        {
          value: '12:00',
        },
        {
          value: '13:00',
        },
        {
          value: '17:00',
        },
      ], // 建议出发时间
      dayAtrribute: {
        dest: null,
        trip_type: '',
        trip_mode: '',
        recommend_time: '',
        remarkDayTrip: '',
      },
      destShowBack: null,
      select_time: null,
      dayTrip: [],
      TrafficPlanList: [],
      lat: null,
      lng: null,
      selectTraver: [],
      traver_between: [],
      TraverNameBetween: [],
      TrafficIntroduce: '',
      TaxiIntroduce: '',
      TaxiFare: '',
      TrafficPlan: [],
      // 交通
      TrafficId: null,
      planData: [], // 显示交通方案的数据，
      planOfMap: null,
      // 交通地图
      routeMode: 'walking',
      fromLat: 39.984039,
      fromLng: 116.30763,
      toLat: 39.977263,
      toLng: 116.337063,
      policy: '',
      showTransit: false,
      showDriving: false,
      //
      filterBlock: ``,
    }
  },
  computed: {},
  mounted() {
    this.filterBlock = `height:${this.getMapHeight() + 45}px`
    //
    this.dayAtrribute.trip_id = this.$route.query.id
    this.getDayTripDetail(this.$route.query.id)
  },
  methods: {
    showOrHideMapFunction() {
      this.$nextTick(() => {
        this.filterBlock = `height:${this.getMapHeight() + 10}px`
      })
    },
    getMapHeight() {
      // console.log(mapHeight)
      let mapHeight = document.getElementById('get_map_height').offsetHeight
      return mapHeight
    },
    // 选择建议时间
    suggestTimeChange(val) {
      this.dayAtrribute.recommend_time = val
    },
    // 选择目的地
    selectDest(val) {
      this.dayAtrribute.dest = val
    },
    // 检查数据
    checkDayTripList() {
      console.log(this.dayTrip)
    },
    // 保存日行程
    updateDayTripList() {
      // console.log('dayTrip', this.dayTrip)
      // 日行程基本信息
      // console.log(this.dayAtrribute)
      // 日行程迹点列表
      let dayTripListPost = []

      this.dayTrip.forEach((i) => {
        // console.log('i', i)
        // 遍历获取迹点的交通方案
        let i_traffic_plan_list = []
        if (i.TrafficPlan) {
          for (let item of i.TrafficPlan) {
            let traffic_item = {
              traffic_plan_id: item.traffic_plan_id,
              index: i.TrafficPlan.indexOf(item),
            }
            i_traffic_plan_list.push(traffic_item)
          }
        }
        // 遍历/添加 迹点 到列表
        let dayTripItem = {
          traver_id: i.id,
          traffic_id: i.traffic_id,
          traffic_plan: i_traffic_plan_list,
          index: this.dayTrip.indexOf(i),
        }
        dayTripListPost.push(dayTripItem)
      })
      this.dayAtrribute['dayTripList'] = dayTripListPost
      // 提交的数据
      console.log('post', this.dayAtrribute)
      // return
      // 检查数据，发送请求保存日行程：
      this.$http
        .post('/traver/update_day_trip', this.dayAtrribute)
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.$router.push({ name: 'day_trip_list' })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 选择交通方案
    selectTrafficPlan(val, traver_id) {
      this.TrafficPlanList = val
      this.dayTrip.forEach((item) => {
        if (item.id == traver_id) {
          // 动态给对象添加属性
          this.$set(item, 'TrafficPlan', val)
        }
      })
    },
    // 点击 添加/选择 交通button，间的 poi_id 更新地图折线
    openTrafficEditor(traver, next_traver) {
      this.routeMode = 'walking'
      this.TrafficIntroduce = ''
      // 步骤：
      // 1.前后迹点 获取已保存的交通方案 -》
      // 2.获取出发点坐标、抵达
      // 3.添加地图点标记
      // 4.添加 交通折线
      // console.log('获取两点直接的坐标，并绘制点比较和 路线规划')
      // ------------------------------------------------------
      // 1.
      //将迹点id 传递给交通组件
      this.traver_between = []
      this.traver_between.push(traver.id)
      this.traver_between.push(next_traver.id)
      // 创建/查找交通信息和方案【traffic_class=1：点点之间的交通】

      this.$http
        .get(
          `/traver/match_traffic_two_poi?poi_list=${[
            traver.poi_id,
            next_traver.poi_id,
          ]}&traffic_class=1`
        )
        .then((res) => {
          // console.log('请求亮点直接的数据')
          if (res.data.errno == '0') {
            // 获得交通id
            // console.log(res)
            this.TrafficId = res.data.data.traffic_id
            this.TaxiIntroduce = res.data.data.take_taxi
            // 交通方案
            this.TrafficPlan = res.data.plan
            // console.log(this.TrafficPlan)
            // 将打车信息添加到日行程-迹点-信息里
            this.dayTrip.forEach((i) => {
              if (i.id == traver.id) {
                i['take_taxi'] = this.TaxiIntroduce
                i['traffic_id'] = this.TrafficId
              }
            })
            // console.log(this.dayTrip)
          }
        })
      // 两点之间的名字，用于更新到交通组件
      this.TraverNameBetween = []
      this.TraverNameBetween.push(traver.traver_title)
      this.TraverNameBetween.push(next_traver.traver_title)
      // ------------------------------------------------------
      new Promise((resolve, reject) => {
        // 2.
        // 获取出发点坐标、抵达 ：
        this.$http
          .get(
            `/traver/get_lat_lng?poi_id=${traver.poi_id}&next_poi=${next_traver.poi_id}`
          )
          .then((res) => {
            if (res.data.errno == '0') {
              // console.log(res.data)
              this.fromLat = parseFloat(res.data.data.lat)
              this.fromLng = parseFloat(res.data.data.lng)
              this.toLat = parseFloat(res.data.next_data.lat)
              this.toLng = parseFloat(res.data.next_data.lng)
              resolve()
            }
          })
      }).then((res) => {
        // console.log(this.fromLat)
        // 3.
        // --------------------------添加地图处理点标记--------------------------
        // 删除原有的点标记
        this.$refs.show_route_maps.removeMarkerPointer(1)
        this.$refs.show_route_maps.removeMarkerPointer(2)
        // 更新地图点标记
        let from_to_list = [
          {
            id: 1, // 开始的 marker_id
            lat: this.fromLat,
            lng: this.fromLng,
          },
          {
            id: 2, // 结束的 marker_id
            lat: this.toLat,
            lng: this.toLng,
          },
        ]
        // 添加标记点
        this.$refs.show_route_maps.addMarkerPointerCenter(from_to_list)
        // 4.
        // -----------------服务端获取 ->更新 路线规划数据-----------------
        // 判断是否有 标点 和规划路线
        // if (this.TrafficId == null) {
        // } else {
        //   // 移除之前的折线
        //   this.$refs.show_route_maps.removeRoutes(this.TrafficId)
        // }
        // 根据 路线模式获取路线数据
        if (this.routeMode == 'transit') {
          this.planData = []
          this.planData = res.data.data
        } else if (this.routeMode == 'bicycling') {
          this.planData = []
          this.planData = res.data.data
        } else if (this.routeMode == 'walking') {
          this.planData = []
          this.$http
            .get(
              `/traver/api_map_qq_routes_walking?from_lat=${this.fromLat}&from_lng=${this.fromLng}&to_lat=${this.toLat}&to_lng=${this.toLng}&route_mode=${this.routeMode}`
            )
            .then((res) => {
              if (res.data.errno == '0') {
                // 获取交通说明
                if (res.data.data[0].distance > 1000) {
                  this.TrafficIntroduce =
                    '距离：' +
                    res.data.data[0].distance / 1000 +
                    '公里，耗时约：' +
                    res.data.data[0].duration +
                    '分钟'
                } else if (res.data.data[0].distance < 1000) {
                  this.TrafficIntroduce =
                    '距离：' +
                    res.data.data[0].distance +
                    '米，耗时约：' +
                    res.data.data[0].duration +
                    '分钟'
                }

                // 解压poyline
                let pl = this.underPolyline(res.data.data[0].polyline)
                // 更新路线
                this.$refs.show_route_maps.updateRoutes([
                  {
                    id: this.traffic_id,
                    styleId: 'style_walking',
                    paths: pl,
                  },
                ]) // 添加路线 (paths,TrafficId,routeMode)
                // this.$refs.show_route_maps.addRoutesAndPoint(
                //   pl,
                //   this.traffic_id,
                //   this.routeMode
                // )
              }
            })
        } else if (this.routeMode == 'driving') {
          // 驾车方案：
          this.planData = []
          console.log('driving')
          this.getDrivingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode
          )
        }
        // -----------------【结束】服务端获取 ->更新 路线规划数据-----------------
      })
    },
    // 切换交通模式:步行，自驾，等
    clickRouteMode() {
      // this.routeMode = val.name
      this.$nextTick(() => {
        // 判断是否有 标点 和规划路线
        // if (this.TrafficId == null) {
        // } else {
        //   console.log('移除已有折线:', this.TrafficId)
        //   this.$refs.show_route_maps.removeRoutes(this.TrafficId)
        // }
        // 打印交通方式
        // console.log(this.routeMode)
        if (this.routeMode == 'transit') {
          this.showTransit = true
          this.showDriving = false
          this.planData = []
          this.getTransitRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode,
            this.policy
          )
        } else if (this.routeMode == 'bicycling') {
          this.showTransit = false
          this.showDriving = false
          this.planData = []
          // console.log('bicycling')
          this.getBicyclingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode
          )
        } else if (this.routeMode == 'walking') {
          this.showTransit = false
          this.showDriving = false
          this.planData = []
          // console.log('walking')
          this.getWalkingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode
          )
        } else if (this.routeMode == 'driving') {
          this.showTransit = false
          this.showDriving = true
          // 驾车
          this.planData = []
          // console.log('driving')
          this.getDrivingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode,
            this.policy
          )
        }
      })
    },
    // 获取【步行】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getWalkingRoutesFromAPI(fromLat, fromLng, toLat, toLng, routeMode) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_walking?from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            // 获取交通说明
            if (res.data.data[0].distance > 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance / 1000 +
                '公里，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            } else if (res.data.data[0].distance < 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance +
                '米，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            }
            // 解压poyline
            let pl = this.underPolyline(res.data.data[0].polyline)

            // 更新路线
            this.$refs.show_route_maps.updateRoutes([
              {
                id: this.traffic_id,
                styleId: 'style_walking',
                paths: pl,
              },
            ])
            // this.$refs.show_route_maps.updateBack(
            //   res.data.data[0],
            //   this.TrafficId,
            //   this.routeMode
            // )
          }
        })
    },

    // 获取【骑行】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getBicyclingRoutesFromAPI(fromLat, fromLng, toLat, toLng, routeMode) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_bicycling?from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            // 获取交通说明
            this.TrafficIntroduce =
              '距离：' +
              res.data.data[0].distance / 1000 +
              '公里，耗时约：' +
              res.data.data[0].duration +
              '分钟'
            // 解压poyline
            let pl = this.underPolyline(res.data.data[0].polyline)

            // 更新路线
            this.$refs.show_route_maps.updateRoutes([
              {
                id: this.traffic_id,
                styleId: 'style_bicycling',
                paths: pl,
              },
            ])
          }
        })
    },
    // 获取【驾车】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getDrivingRoutesFromAPI(fromLat, fromLng, toLat, toLng, routeMode, policy) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_driving?from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}&policy=${policy}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            console.log(res.data.data)
            // 解压
            res.data.data.forEach((route) => {
              this.deCompressionPolyline(route.polyline)
            })
            // 方案选项
            this.planData = res.data.data
            // 获取交通说明
            if (res.data.data[0].distance > 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance / 1000 +
                '公里，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            } else if (res.data.data[0].distance < 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance +
                '米，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            }
            // 打车费用约：[服务端返回，所以不用保存]
            this.TaxiFare =
              '打车费用约：' + res.data.data[0].taxi_fare.fare + '元'
            // 解压poyline
            let pl = this.getPolyLineLatLng(res.data.data[0].polyline)

            // 更新路线
            this.$refs.show_route_maps.updateRoutes([
              {
                id: this.traffic_id,
                styleId: 'style_driving',
                paths: pl,
              },
            ])
          }
        })
    },
    // 获取【公共交通】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getTransitRoutesFromAPI(fromLat, fromLng, toLat, toLng, routeMode, policy) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_transit?from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}&policy=${policy}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            // console.log('服务端获取的数据')
            // 1.显示方案选项
            this.planData = res.data.data
            // 2.获取交通说明
            // this.TrafficIntroduce =
            // 3.更新路线 循环
            let pl_list = []
            //   {
            //   id: TrafficId,
            //   styleId: 'style_blue',
            //   paths: pl,
            // }
            // 全部数据都解压一遍
            res.data.data.forEach((route) => {
              //console.log(route) //坐标解压（返回的点串坐标，通过前向差分进行压缩）
              route.steps.forEach((route_step) => {
                if (route_step.mode == 'WALKING') {
                  // 解压 步行
                  let coors = route_step.polyline
                  //坐标解压（返回的点串坐标，通过前向差分进行压缩）
                  let kr = 1000000
                  for (let i = 2; i < coors.length; i++) {
                    coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
                  }
                } else if (route_step.mode == 'TRANSIT') {
                  route_step.lines.forEach((line) => {
                    let coors = line.polyline
                    //坐标解压（返回的点串坐标，通过前向差分进行压缩）
                    let kr = 1000000
                    for (let i = 2; i < coors.length; i++) {
                      coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
                    }
                  })
                }
              })
            })
            // 解压完毕,开始绘制
            res.data.data[0].steps.forEach((step_item) => {
              // 根据腾讯提供的数据接口[步行 , 公交 , 步行 , 公交 , 步行(到终点)]
              if (step_item.mode == 'WALKING') {
                // console.log('步行')--------------------------
                let pl = this.getPolyLineLatLng(step_item.polyline)

                // 构建 pl_list_item
                let pl_wlaking_item = {
                  id: this.traffic_id,
                  styleId: 'style_walking',
                  paths: pl,
                }
                pl_list.push(pl_wlaking_item)
              } else if (step_item.mode == 'TRANSIT') {
                // console.log("公共交通")--------------------------
                step_item.lines.forEach((line_item) => {
                  if (line_item.vehicle == 'BUS') {
                    // console.log('搭乘公共汽车')
                    // 搭乘公共汽车
                    let pl = this.getPolyLineLatLng(line_item.polyline)
                    let pl_wlaking_item = {
                      id: this.traffic_id + line_item.id,
                      styleId: 'style_bus',
                      paths: pl,
                    }
                    pl_list.push(pl_wlaking_item)
                  } else if (line_item.vehicle == 'SUBWAY') {
                    // console.log('搭乘地铁')
                    // 搭乘地铁
                    let pl = this.getPolyLineLatLng(line_item.polyline)
                    let pl_wlaking_item = {
                      id: this.traffic_id + line_item.id,
                      styleId: 'style_subway',
                      paths: pl,
                    }
                    pl_list.push(pl_wlaking_item)
                  } else if (line_item.vehicle == 'RAIL') {
                    // console.log('搭乘火车')
                    // 搭乘火车
                    let pl = this.getPolyLineLatLng(line_item.polyline)
                    let pl_wlaking_item = {
                      id: this.traffic_id + line_item.id,
                      styleId: 'style_rail',
                      paths: pl,
                    }
                    pl_list.push(pl_wlaking_item)
                  }
                })
              }
            })
            // 通过refs，批量添加折线
            // console.log(pl_list)
            //新的折线添加到图层中
            this.$refs.show_route_maps.updateRoutes(pl_list)

            //
          }
        })
    },
    // 解压 polyline + 生成坐标
    underPolyline(polyline) {
      let coors = polyline
      let pl = []
      //坐标解压（返回的点串坐标，通过前向差分进行压缩），提前解压
      let kr = 1000000
      for (let i = 2; i < coors.length; i++) {
        coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
      }
      //将解压后的坐标生成LatLng数组
      for (var i = 0; i < coors.length; i += 2) {
        pl.push(new TMap.LatLng(coors[i], coors[i + 1]))
      }
      return pl
    },
    // 解压 polyline  deCompressionPolyline()
    deCompressionPolyline(polyline) {
      let coors = polyline
      let pl = []
      //坐标解压（返回的点串坐标，通过前向差分进行压缩），提前解压
      let kr = 1000000
      for (let i = 2; i < coors.length; i++) {
        coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
      }
      return pl
    },
    // 生成坐标
    getPolyLineLatLng(coors) {
      let pl = []
      //将解压后的坐标生成LatLng数组
      for (var i = 0; i < coors.length; i += 2) {
        pl.push(new TMap.LatLng(coors[i], coors[i + 1]))
      }
      return pl
    },
    // 选择交通方案
    bandTransitPlan(item, introduce) {
      // console.log(item)
      this.TrafficIntroduce = introduce
      this.planOfMap = item
    },
    //选取迹点 ，判断是添加还是移除， this.selectTraver已选择的迹点ID
    checkOneItemToDayTrip(val) {
      // 判断是否有已选迹点

      if (this.selectTraver.length == 0) {
        this.dayTrip = []
      } else {
        // 去掉 取消的迹点
        this.dayTrip.forEach((i) => {
          if (i.id == val) {
            this.dayTrip.splice(this.dayTrip.indexOf(i), 1)
          }
        })
      }
      console.log(this.dayTrip)
      // 是否已选
      let arrItemIndex = this.selectTraver.indexOf(val)

      if (arrItemIndex > -1) {
        // console.log('有这个ID')
        this.getTraverPointInfo(val)
        // 如果在，删除这个迹点id
        // this.selectTraver.splice(arrItemIndex, 1)
        // 并，删除 日行程列表里的对应信息
        // console.log(this.dayTrip)
      } else {
        // 如果不再，将迹点id添加到selectTraver
        // this.selectTraver.push(val)
        // 并， 获取迹点信息加到daytrip列表
        // this.getTraverPointInfo(val)
      }
    },
    //
    getTraverPointInfo(id) {
      this.$http
        .get(`/traver/get_traver_point_traver_id?traver_id=${id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.dayTrip.push(res.data.data)
          }
        })
    },
    // ---------------  获取 起点 和终点的 坐标 ---------------
    selectDrivingPlan(pl_list) {
      // console.log(pl_list)
      this.$refs.show_route_maps.updateRoutes(pl_list)
    },
    selectTransitPlan(pl_list) {
      this.$refs.show_route_maps.updateRoutes(pl_list)
      // 保存将路线保存到数据库
    },
    // ---------------  获取 起点 和终点的 坐标 ---------------
    // 获取日行程信息
    getDayTripDetail(trip_id) {
      // 获取迹点信息
      this.$http
        .get(`/traver/get_day_trip_info?trip_id=${trip_id}`)
        .then((res) => {
          console.log('获取日行程', res)
          if (res.data.errno == '0') {
            this.dayAtrribute.dest = parseInt(res.data.dayTrip.dest_id)
            this.dayAtrribute.recommend_time = res.data.dayTrip.recommend_time
            this.destShowBack = parseInt(res.data.dayTrip.dest_id)
            this.select_time = res.data.dayTrip.recommend_time
            this.dayAtrribute.trip_type = res.data.dayTrip.trip_type
            this.dayAtrribute.trip_mode = res.data.dayTrip.trip_mode
            this.dayAtrribute.remarkDayTrip = res.data.dayTrip.remark
            // 迹点列表
            this.dayTrip = res.data.traverList
            // 迹点id列表回显
            let check_list = []

            res.data.traverList.forEach((item) => {
              check_list.push(item.id)
            })
            this.selectTraver = check_list
            // console.log('初始化selectTraver', this.selectTraver)

            this.$refs.select_traver_point.showSelectTraverList = check_list
          }
        })

      // 获取交通方案赋值给 到交通
    },
  },
}
</script>

<style>
.trip_attritube_style {
  margin-bottom: 5px;
}
.traffit-between-traver-point {
  width: 300px;
}
.tab-way-map .el-tabs__content {
  padding: 0;
  width: 480px;
}
</style>